<template>
  <div class="text-center mb-6">
    <p class="text-black font-semibold text-lg md:text-xl bg-primary/5 py-3 px-4 rounded-xl inline-block">
      ⚡ Se você não tem <span class="highlight">1 minuto para resolver isso</span>, já está perdendo tempo.
    </p>
  </div>
</template>

<style scoped>
.highlight {
  background-color: rgba(160, 75, 153, 0.1);
  padding: 0.2rem 0.5rem;
  border-radius: 0.3rem;
  font-weight: 600;
}
</style>